module.exports = __webpack_public_path__ + "img/pasos1-3.33e3484b.png";